/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The mode of the policy. 
*/
export enum ScheduleMode {
  SCHEDULE_MODE_UNSPECIFIED = 'UNSPECIFIED',
  SCHEDULE_MODE_BASIC = 'BASIC',
  SCHEDULE_MODE_ADVANCED = 'ADVANCED'
}
